import React from 'react'
import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import DropDownOA from '../../../../common/dropDownOA'
import { connect } from 'react-redux'
import { getPartyList, updateAlertError, updateModal } from '../../../../../store/common/common_action'
import * as mdt from '../../../../common/modaltypes'
import { useState } from 'react'
import { useEffect } from 'react'
import { focusElemnt, getFloat, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../../common/helper'
import { corporateRateMatrixInsertUpdate, getCorporateRateMatrix, getPartyWeightChrg, updatePartyWeightChrg, } from '../../../../../store/generalSetting/GSAction'
import ConfirmModal from './ConfirmModal'
import UpdateChrgWeightModal from './UpdateChrgWeightModal'
import {  corporateRateHead, corporateRateMatrixObj } from './constant'
import SuccessAndErrorModal from '../../../../common/SuccessAndErrorModal'
import { cargoServiceTypes, standarRateChrgOnlyKGOpt, standarRateOthChrgOpt } from '../../StandardRateMatrix/rateMatrixConstants'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import LineinputV2 from '../../../../common/lineinputV2'
import { getFocApprConsTypeData,  getServiceTypeListAllData } from '../../../../../store/generalSetting/GSAction'

const CorporateRateMatrixNew = (props) => {
    const { data, updateModal, updateAlertError, getFocApprConsTypeData, getCorporateRateMatrix,getPartyList, corporateRateMatrixInsertUpdate, getServiceTypeListAllData,getPartyWeightChrg, tabData,goToTabs, updatePartyWeightChrg } = props
    const { common, generalSettingReducer } = data
    const { loginData, showModal, modalType , partyList} = common
    const { focApprConsTypeData, serviceTypeListAll, serviceTypeListAll2 } = generalSettingReducer
    const [selParty, setSelParty] = useState('')
    const [partyListData, setPartyListData] = useState([])
    const [selectedServiceType, setSelectedServiceType] = useState(cargoServiceTypes[0])
    const [filterOpt, setFilterOpt] = useState({
      consType: [],
      CargoServiceType: [],
      chrgType: standarRateChrgOnlyKGOpt
    })
    const [filterValue, setFilterValue] = useState({
      consType: '',
      CargoServiceType: ''
    })
    const [showTable, setShowTable] = useState(false)
    const [tableData, setTableData] = useState([])
    const [isSuccess, setIsSuccess] = useState(false)
  
    const modalStyle = {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }
    useEffect(() => {
      if (!isEmpty(loginData)) {
        let obj = {
          intConsignmentSubTypeID: 0,
          intCompanyID: loginData?.intCompanyID,
          intConsignmentTypeID: 0,
          strSubType: "",
          intIsActive: 1,
          intIsDeleted: 0
        }
        getFocApprConsTypeData(obj, true, 24 * 60 * 60 * 1000)
      }
    }, [loginData])
      useEffect(() => {
        if (!isEmpty(loginData)) {
          let multiCargoBody = {
            CargoServiceType: -1,
            CompanyID: loginData?.intCompanyID,
            IsActive: 1
          }
          getServiceTypeListAllData(multiCargoBody)
        }
      }, [ loginData])
    useEffect(() => {
      if (serviceTypeListAll?.length > 0) {
        let data = serviceTypeListAll?.filter((val) => serviceTypeListAll2?.length > 0 ? serviceTypeListAll2?.[0]?.CargoServiceTypeID === 0 ? val?.ServiceTypeID === 2 : true : true)
        if (Number(serviceTypeListAll2?.[0]?.CargoServiceTypeID) === 1) {
          data.unshift({ ServiceTypeID: 0, ServiceType: 'All' })
          setSelectedServiceType(cargoServiceTypes[1])
        } else {
          setSelectedServiceType(cargoServiceTypes[0])
        }
        setFilterOpt((prev) => ({
          ...prev,
          CargoServiceType: data
        }))
        setFilterValue((prev) => ({
          ...prev,
          CargoServiceType: data[0]
        }))
      } else {
        setFilterOpt((prev) => ({
          ...prev,
          CargoServiceType: []
        }))
        setFilterValue((prev) => ({
          ...prev,
          CargoServiceType: []
        }))
      }
    }, [serviceTypeListAll, serviceTypeListAll2])
    useEffect(() => {
      if (!isEmpty(loginData)) {
        //getCorporateRateMatrixList()
        const obj = {
          intPartyID: 0,
          intCompanyID: loginData?.intCompanyID,
          strPartyName: '',
          strContactPerson: '',
          intCityID: 0,
          intIsCreditParty: 0,
          intIsActive: -1,
          intIsDeleted: 0,
        }
        getPartyList(obj)
      }
    }, [loginData])
    useEffect(() => {
      if (focApprConsTypeData?.length > 0) {
        let newData = []
        focApprConsTypeData.map(function (obj) {
          newData.push({
            ...obj,
            id: obj.ConsignmentSubTypeID,
            name: obj.SubType,
          })
        })
        newData = removeDuplicatesFromArray(newData, `id`)
        newData.sort((a, b) => a.name.localeCompare(b.name))
        let defConsType = newData[0]
        setFilterValue((prev) => ({
          ...prev,
          consType: newData[0]
        }))
        let defChrg = standarRateChrgOnlyKGOpt?.filter((obj) => {
          if (defConsType?.BillingUnit === 1 && defConsType?.IsKgKm === 1) {
            return [1]?.includes(obj?.id)
          } else if (defConsType?.BillingUnit === 1 && defConsType?.IsKgKm === 0) {
            return [1]?.includes(obj?.id)
          } else {
            return [2]?.includes(obj?.id)
          }
        })
        setFilterOpt((prev) => ({
          ...prev,
          consType: newData,
          chrgType: defChrg
        }))
      } else {
        setFilterOpt((prev) => ({
          ...prev,
          consType: []
        }))
        setFilterValue((prev) => ({
          ...prev,
          consType: []
        }))
      }
      resetValue()
    }, [focApprConsTypeData, serviceTypeListAll])
    const resetValue = () => {
      setShowTable(false)
      setTableData([])
    }
    const handleLoadBtn = () => {
      resetValue()
      if (selParty == ''||selParty==undefined) {
        updateAlertError({ show: true, msg: "Select Party..!", nextId: 'Select_Party' })
      }else if (filterValue?.CargoServiceType === '') {
        updateAlertError({ show: true, msg: 'Please Select Multi Cargo Service Type', success: false, nextId: `` })
      } else if (filterValue?.consType === '') {
        updateAlertError({ show: true, msg: 'Please Select Consignment Type', success: false, nextId: `` })
      } else {
        const body = {
          PartyID: selParty?.PartyID,
          CompanyID: loginData?.intCompanyID,
          ConsignmentTypeID: filterValue?.consType?.id,
          ServiceTypeID:filterValue?.CargoServiceType?.ServiceTypeID,
          CargoServiceTypeID: selectedServiceType?.id,
        }
        getCorporateRateMatrix(body).then((res) => {
          if (res.status === 'Success') {
            let data = res?.Data?.Table
            if (filterValue?.CargoServiceType?.ServiceTypeID === 0) {
              handleChrgDefValue(filterOpt?.CargoServiceType?.filter((val) => val.ServiceTypeID !== 0), data)
            } else {
              handleChrgDefValue([filterValue?.CargoServiceType], data)
            }
          } else {
            updateAlertError({ show: true, msg: 'No Data', nextId: '' })
          }
        }).catch((error) => {
          updateAlertError({ show: true, msg: error, nextId: '' })
        })
      }
    }
  
    const handleChrgDefValue = (CargoServiceType = [], data = []) => {
      let newData = []
      CargoServiceType.forEach((obj) => {
        let findService = data.filter((val) => Number(val?.ServiceTypeID) === Number(obj?.ServiceTypeID))
        if (findService?.length === 0) {
          newData.push({
            ...corporateRateMatrixObj,
            ServiceTypeID: Number(obj?.ServiceTypeID),
            ServiceType: obj?.ServiceType
          })
        } else {
          findService.forEach((val) => {
            let chrgObj = { ...val }
            Object.keys(val).forEach((key) => {
              if (["CollCartageType", "DelCartageType", "DocChgType", "ValuationType", "DeliveryChgType", "HamaliChgType", "LaborChgType", "FreightType", "PickupChgType", "DropoffChgType", "ConvChgType", "DelOpHamaliType", "DelCartageOnDelType", "DemurrageType"].includes(key)) {
                let defValue = (key === 'FreightType' ? standarRateChrgOnlyKGOpt : standarRateOthChrgOpt)?.filter((obj) => obj.id === val[key])?.[0]?.id || 0
                chrgObj[key] = defValue
              }
            });
            newData.push(chrgObj)
          })
        }
      })
      setTableData(newData.sort((a, b) => a.ServiceTypeID - b.ServiceTypeID))
      setShowTable(true)
    }
    const handleCharge = (index, field, value) => {
      const newData = [...tableData]
      newData[index][field] = value
      setTableData(newData)
    }
    const CustomTableCell = (props) => {
      const { data, index, field, dataDropDown, fieldDropDown, tableData, colIndex } = props
      let defValue = (fieldDropDown === 'FreightType' ? standarRateChrgOnlyKGOpt : standarRateOthChrgOpt)?.filter((obj) => obj.id === dataDropDown)?.[0]?.name || ''
      return (
        <div className='standard-rate-dropdown'>
          <DropDownOA
            data={fieldDropDown === 'FreightType' ? standarRateChrgOnlyKGOpt : standarRateOthChrgOpt}
            defaultvalue={defValue}
            idKey={`id`}
            id={`dropDown-${index}-${colIndex}`}
            dataKey={`name`}
            nextId={colIndex === 14 ? `input-${index}-${1}` : `dropDown-${index}-${colIndex + 1}`}
            prevId={index === 0 && colIndex === 1 ? 'save_btnRateMatrix' : colIndex === 1 ? `input-${index - 1}-${14}` : `dropDown-${index}-${colIndex - 1}`}
            width={'100%'}
            noCross={false}
            listWidth='250px'
            onSelect={(val) => {
              const newData = [...tableData]
              newData[index][fieldDropDown] = val?.id || 0
              setTableData(newData)
            }}
            onReset={() => {
              const newData = [...tableData]
              newData[index][fieldDropDown] = 0
              newData[index][field] = 0
              setTableData(newData)
            }}
            portal={true}
          />
          <div className="input--wrapper">
            <LineinputV2
              id={`input-${index}-${colIndex}`}
              value={data}
              name="chrg_value"
              type="text"
              filter={getFloat}
              onBlur={(event) => {
                handleCharge(index, field, event.target.value)
                if (event.key === 'Enter') {
                  setTimeout(() => {
                    focusElemnt((colIndex === 14 && tableData.length - 1 === index) ? 'Service_Type' : colIndex === 14 ? `dropDown-${index + 1}-${1}` : `input-${index}-${colIndex + 1}`)
                  }, 0)
                } else if (event.key === 'Escape') {
                  setTimeout(() => {
                    focusElemnt(colIndex === 1 ? `dropDown-${index}-${14}` : `input-${index}-${colIndex - 1}`)
                  }, 0)
                }
              }}
            />
          </div>
        </div>
      )
    }
   
    const transferArrToObject = (arr) => {
      const newObject = arr.reduce((result, obj) => {
        Object.keys(obj).forEach(key => {
          result[key] = result[key] ? `${result[key]}^${obj[key]}` : `${obj[key]}`;
        });
        return result;
      }, {});
      return newObject
    }
    const handleSaveRate = () => {
      let tableDataObj = transferArrToObject(tableData)
      const obj = {
        PartyID: selParty?.PartyID,
        CompanyID: loginData?.intCompanyID,
        CargoServiceType: selectedServiceType?.id,
        ConsignmentType: filterValue?.consType?.id,
        ServiceTypeIDs: tableDataObj?.ServiceTypeID || '',//not sure
        CollCartage: tableDataObj?.CollCartage|| '',
        CollCartageType: tableDataObj?.CollCartageType|| '',
        DelCartage: tableDataObj?.DelCartage|| '',
        DelCartageType: tableDataObj?.DelCartageType|| '',
        DocChg: tableDataObj?.DocChg|| '',
        DocChgType: tableDataObj?.DocChgType|| '',
        Valuation: tableDataObj?.ValuationChg|| '',
        ValuationType: tableDataObj?.ValuationType|| '',
        DeliveryChg: tableDataObj?.DeliveryChg|| '',
        DeliveryChgType: tableDataObj?.DeliveryChgType|| '',
        HamaliChg: tableDataObj?.HamaliChg|| '',
        HamaliChgType: tableDataObj?.HamaliChgType|| '',
        LaborChg: tableDataObj?.LaborChg|| '',
        LaborChgType: tableDataObj?.LaborChgType|| '',
        FreightChg: tableDataObj?.Freight|| '',
        FreightChgType: tableDataObj?.FreightType|| '',
        PickupChg: tableDataObj?.PickupChg|| '',
        PickupChgType: tableDataObj?.PickupChgType|| '',
        DropoffChg: tableDataObj?.DropoffChg|| '',
        DropoffChgType: tableDataObj?.DropoffChgType|| '',
        ConvChg: tableDataObj?.ConvChg|| '',
        ConvChgType: tableDataObj?.ConvChgType|| '',
        DelOpHamali: tableDataObj?.DelOpHamali|| '',
        DelOpHamaliType: tableDataObj?.DelOpHamaliType|| '',
        DelCartageOnDel: tableDataObj?.DelCartageOnDel|| '',
        DelCartageOnDelType: tableDataObj?.DelCartageOnDelType|| '',
        Demurrage: tableDataObj?.Demurrage|| '',
        DemurrageType: tableDataObj?.DemurrageType|| '',
        UserID: loginData?.intUserID
      }
      corporateRateMatrixInsertUpdate(obj).then((res) => {
        if (res?.status == 'Successs') {
          setIsSuccess(true)
        } else {
          updateAlertError({ show: true, msg: res.Message, success: false, nextId: 'gicGSTNo' })
        }
      }).catch((err) => {
        console.log("Error:", err)
      })
    }
   
    const chargeWeightModal = () => {
      const data = {
        isUpdate: false,
        headText: 'Update Charge Weight',
        loginData: loginData,
        ConsignmentTypeList: focApprConsTypeData,
        partyList: partyListData,
      }
      return (
        <UpdateChrgWeightModal
          data={data}
          updateModal={updateModal}
          updateAlertError={updateAlertError}
          getPartyWeightChrg={getPartyWeightChrg}
          updatePartyWeightChrg={updatePartyWeightChrg}
          isSuccess={isSuccess}
          setIsSuccess={setIsSuccess}
        />
      )
    }
    useEffect(() => {
      if (partyList?.length > 0) {
        let filteredParties = partyList?.filter((item)=>item.IsCorporateParty===1)
        setPartyListData(filteredParties)
        if (!isEmpty(tabData)) {
          let selectedParty = filteredParties.filter((item) => item.PartyID === tabData?.PartyID);
          setSelParty(selectedParty?.[0]);
        } else {
          setSelParty(filteredParties?.[0]);
        }
      }
    }, [partyList, tabData]);
    const handleSuccessModalClose = () => {
      setIsSuccess(false)
      handleLoadBtn()
      focusElemnt('gicGSTNo')
      if(!isEmpty(tabData)){
        goToTabs(1, {})
      }
    }
    return (<>
      <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', margin: '10px 0' }}>
        <Box sx={{ ...sx.reportFlex, flexWrap: 'nowrap' }} className="reportButtons">
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={'select_party'}
              label={'Select Party'}
              data={partyListData}
              defaultvalue={selParty?.Party}
              idKey={`PartyID`}
              dataKey={`Party`}
              minWidth="150px"
              nextId={'cargo_service_type'}
              onSelect={(val) => {
                setSelParty(val)
              }}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={'Cargo_Service_Type'}
              label={'Cargo Service Type'}
              data={cargoServiceTypes}
              defaultvalue={selectedServiceType.name}
              onSelect={(seviceType) => {
                setSelectedServiceType(seviceType)
                resetValue()
              }}
              idKey={`id`}
              dataKey={`name`}
              minWidth="150px"
              nextId={``}
              prevId={``}
              disabled={true}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id='Service_Type'
              label={'Select Service Type'}
              data={filterOpt?.CargoServiceType || []}
              defaultvalue={filterValue?.CargoServiceType?.ServiceType || ''}
              value={filterValue?.CargoServiceType?.ServiceType || ''}
              idKey={`ServiceTypeID`}
              dataKey={`ServiceType`}
              onSelect={(val) => {
                setFilterValue((prev) => ({
                  ...prev,
                  CargoServiceType: val
                }))
                resetValue()
              }}
              nextId={`cons_type`}
              minWidth="150px"
              prevId={tableData?.length > 0 ? `input-${tableData?.length - 1}-${14}` : `search_btnRateMatrix`} />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id='cons_type'
              data={filterOpt?.consType || []}
              defaultvalue={filterValue?.consType?.name || ''}
              value={filterValue?.consType?.name || ''}
              label={'Consignment Type'}
              idKey={`id`}
              dataKey={`name`}
              nextId={`search_btnRateMatrix`}
              prevId={`Service_Type`}
              onSelect={(val) => {
                let defChrg = standarRateChrgOnlyKGOpt?.filter((obj) => {
                  if (val?.BillingUnit === 1 && val?.IsKgKm === 1) {
                    return [1]?.includes(obj?.id)
                  } else if (val?.BillingUnit === 1 && val?.IsKgKm === 0) {
                    return [1]?.includes(obj?.id)
                  } else {
                    return [2]?.includes(obj?.id)
                  }
                })
                setFilterValue((prev) => ({
                  ...prev,
                  consType: val,
                }))
                setFilterOpt((prev) => ({
                  ...prev,
                  chrgType: defChrg
                }))
                resetValue()
              }}
             minWidth="150px"
            />
          </Item>
          <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
            <Button
              variant="contained"
              onKeyDown={(e) => navigation3(e, tableData?.length === 0 ? 'Service_Type' : 'save_btnRateMatrix', 'cons_type', () => { })}
              id={'search_btnRateMatrix'}
              sx={{ width: '100%', paddingY: '6px !important' }}
              className="btn btn-primary"
              onClick={() => handleLoadBtn()}
            >
              Load
            </Button>
          </Item>
          <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
            <Button
              variant="outlined"
              onKeyDown={(e) => navigation3(e, 'Service_Type', 'search_btnRateMatrix', () => { })}
              id={'save_btnRateMatrix'}
              sx={{ width: '100%', paddingY: '6px !important' }}
              className="btn cancel-btn"
              onClick={() => {
                 handleSaveRate()
              }}
              disabled={tableData?.length === 0}
            >
              SAVE
            </Button>
          </Item>
          <Item sx={{ ...sx.itemsx, padding: 0,width:"300px" }} className="disabled-wrapper">
          <Button
                variant="outlined"
                id={'update_chrg_weight_btn'}
                sx={{ width: '100%' }}
                className="receiveitembtn"
                onClick={() => {
                   updateModal(true, 'updateChargeWeightModal')
                }}
                onKeyDown={(e) => navigation3(e, 'select_party', 'history_btn', () => { })}
              >
                UPDATE CHARGE WEIGHT
              </Button>
              </Item>
        </Box></Box>
        <TableContainer component={Paper} className="scrollBlue" style={{
          marginBottom: '5px',
          overflowY: 'visible',
        }}>
          {showTable > 0 && (
            <Table
              stickyHeader
              size="small"
              aria-label="a dense table"
              sx={{
                '&.MuiTableCell-root': {
                  padding: '6px 8px!important',
                },
              }}
            >
              <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
                <TableRow>
                  {corporateRateHead.map((col, index) => (
                    <TableCell
                      key={`TH-${index}`}
                      sx={{
                        ...col.headerSx,
                        backgroundColor: '#DAEDFE',
                        minHeight: '40px',
                        fontSize: '12px',
                        fontWeight: '600',
                        color: '#444',
                        padding: '8px 3px',
                        whiteSpace: 'pre-line'
                      }}
                    >
                      {col.headerName}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {tableData.length > 0 && (
                <TableBody>
                  {tableData.map((item, index) => (
                    <TableRow key={index}
                      sx={{
                        backgroundColor: index % 2 === 0 ? '#ffffff' : '#f5f5f5', // Alternate colors
                      }}
                    >
                      {corporateRateHead.map((col, index1) => (
                        //#F5FAFE
                        <>
                          {['ServiceType']?.includes(col.field) ?
                            <TableCell key={`TC-${index1}`} sx={{ ...col.headerSx, padding: '6px 3px', fontSize: '12px', fontWeight: '600', color: 'rgba(0, 0, 0, 0.87)', backgroundColor: '#F5FAFE' }}>
                               {item?.ServiceTypeID === 1 ? 'By Bus' : item?.ServiceTypeID === 2 ? 'By Cargo' : item?.ServiceTypeID === 3 ? 'By Express Cargo' : 'By Partner Cargo'}
                            </TableCell> :
                            <TableCell key={`TC-${index1}`} sx={{
                              ...col.headerSx, padding: '6px 3px',
                              '.cross--icon': {
                                top: '1px !important',
                                right: '18px !important'
                              }
                            }}>
                              <CustomTableCell colIndex={index1} tableData={tableData} fieldDropDown={col.dropDown} dataDropDown={item[col.dropDown]} data={item[col.field]} field={col.field} index={index} />
                            </TableCell>
                          }
                        </>
  
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              )}
            </Table>
          )}
        </TableContainer>
        <SuccessAndErrorModal handleClose={() => { handleSuccessModalClose() }} open={isSuccess} title={'Corporate Rates\n Saved Successfully!'} modalStyle={modalStyle} />
      {showModal && mdt.demurrageChrgConfModal === modalType ? <ConfirmModal updateModal={updateModal} /> : null}
      {showModal && 'updateChargeWeightModal' === modalType ? chargeWeightModal() : null}
      </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateModal, getFocApprConsTypeData, getCorporateRateMatrix,getPartyWeightChrg, getPartyList,updateAlertError, corporateRateMatrixInsertUpdate, getServiceTypeListAllData, updatePartyWeightChrg }
export default connect(mapStateToProps, mapDispatchToProps)(CorporateRateMatrixNew)
